<template>
  <div class="Subpage">
    <Bigmenu
      :NavStatus="Bignav"
      :Way="2"
      :BackPath="'/Adaptive'"
      :ShowBackBtn="true"
      v-on:cellback="OpenStatus"
      style="z-index: 2"
    ></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container
      v-if="!Bignav"
      :Type="true"
      :ImgUrl="'AD02.png'"
      :Container="Container"
      style="z-index: -6"
    ></Container>
  </div>
</template>

<script>
import Bigmenu from "@/components/Bigmenu.vue";
import Back from "@/components/Back.vue";
import Container from "@/components/Container.vue";
export default {
  name: "AD02",
  data() {
    return {
      Bignav: false,
      Container: {
        subtitle: "",
        videosrc: "",
        title: "適應性療法的關鍵 HyperSight",
        list: [
          {
            title: "前所未有的影像品質",
            body: [
              "透過增強對比解析度、抑制假影和降低不均勻性來改善影像品質。",
              "可提高精確鎖定腫瘤體積的能力，並在治療過程中盡可能保留健康組織。",
              "金屬假影抑制演算法可改善體內標記、髖關節假體以及金屬或牙齒植入患者的影像品質。",
              "更大的照野 (FOV) 可讓臨床醫師更清楚看到病患生理構造的變化，進而觸發調整。"
            ]
          },
          {
            title: "精準計算",
            body:
              "提供媲美傳統 CT 掃描HU精確度，從而可以直接在 CBCT 影像上計算劑量分佈，生成精確的治療計畫。"
          },
          {
            title: "高速治療",
            body:
              "只需單次閉氣即可完成，減少假影以及在治療床上的時間，藉此降低患者的不適和焦慮。"
          }
        ]
      }
    };
  },
  components: {
    Back,
    Container,
    Bigmenu
  },
  methods: {
    OpenStatus(v) {
      this.Bignav = v.status;
    }
  }
};
</script>
<style lang="scss" scoped>
.Subpage {
  height: 100%;
  width: 100%;
}
.frame {
  position: absolute;
  background-image: url("../../assets/frame.png");
  background-position: center;
  height: 1080px;
  width: 1920px;
}
</style>
